var _desc, _path, _path2, _line, _line2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Map Marker Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Church location map marker with cross symbol")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 15 C35 15, 25 25, 25 40 C25 55, 50 85, 50 85 C50 85, 75 55, 75 40 C75 25, 65 15, 50 15 Z",
    fill: "#5F7A61",
    stroke: "#E5DECF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15 C35 15, 25 25, 25 40 C25 55, 50 85, 50 85 C50 85, 75 55, 75 40 C75 25, 65 15, 50 15 Z",
    fill: "url(#markerGradient)",
    opacity: 0.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 32,
    x2: 50,
    y2: 48,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 40,
    x2: 58,
    y2: 40,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40,
    r: 12,
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "markerGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerIcon);
export default __webpack_public_path__ + "static/media/map-marker-icon.2ff97995e57e832a41ff96c73f4d55c1.svg";
export { ForwardRef as ReactComponent };